import { ReactNode, createContext, useContext, useEffect } from "react";
import { GetCurrentUserQuery } from "gql/graphql";
import { useQuery } from "@apollo/client";
import { GET_CURRENT_USER } from "../api/get-current-user";
import * as Sentry from "@sentry/react";
import { ANONYMOUS_USER } from "../constants";

type UserContext = GetCurrentUserQuery["getCurrentUser"] | null;

export const Context = createContext<UserContext>(null);

export function UserContextProvider({ children }: { children: ReactNode }) {
  const { data, loading } = useQuery(GET_CURRENT_USER);

  useEffect(() => {
    if (data?.getCurrentUser.id) {
      Sentry.setUser({
        id: data.getCurrentUser.id,
      });
    }
  }, [data?.getCurrentUser.id]);

  if (loading || !data) {
    return null;
  }

  return (
    <Context.Provider value={data.getCurrentUser}>{children}</Context.Provider>
  );
}

export function useUser() {
  return useContext(Context);
}

export function useIsUserAuthenticated() {
  const user = useUser();
  return !!user?.username && user?.username !== ANONYMOUS_USER;
}
